import { useEffect, useState } from 'react'
import { getBotUsers } from '../AdminPages/API/Users/Users'
import { BotUser } from '../AdminPages/API/Users/models'

export const useGetAllUsers = () => {
  const [allUsers, setAllUsers] = useState<BotUser[]>([])

  const getAllUsers = async () => {
    const response = await getBotUsers()
    if (response) {
      setAllUsers(response)
    }
  }

  const usersOptions = allUsers?.map((user) => ({
    value: user.id,
    label: user.name
  })) || []

  useEffect(() => {
    getAllUsers()
  }, [])

  return {
    allUsers,
    getAllUsers,
    usersOptions
  }
}
